export const isMouse = window.matchMedia('(any-hover: hover)').matches;
